import React, { ChangeEvent, useContext, useEffect, useState } from "react";

import { createStyles, makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles";

import { SelectChangeEvent, Stack, TableCell, TableFooter, TablePagination, TableRow, Typography, } from "@mui/material";
import { Box, Paper, Snackbar } from "@mui/material";
import { TableContainer } from "@mui/material";
import { TableHead, TableBody } from "@mui/material";

import { BarraDeFerramentas } from "../../../Components/barra-de-ferramentas/BarraDeFerramentas";
import CadernoLayout from "../../../Styles/layout/cadernoLayout";
import TablePaginationActions from "../../../Components/Pagination/pagination";
import { del, get, post } from "../../../Services/tokenConfig";
import ConfirmDialog from "../../../Components/CustomDialog/customdialog";
import LoadingVulpes from "../../../Styles/Loader/loading";
import { ButtonCadernos } from "../../../Components/barra-de-ferramentas/ButtonCadernos";
import { StyledTableCell, StyledTableHead, } from "../../../Styles/tabelCellStyled/customTableCell";
import BasicPopover from "../../../Components/Popover";
import { CustomSelect, CustomTextField, CustomThemeProvider, } from "../../../Styles/theme/customThemeprovider";

import { func_print } from "../../../Func_genericas/func_print";
import { useLocation } from "react-router-dom";
import { especie, finalidade_producao_valor_estatico, modoProducao } from "../../../informacao_estatica";
import { IPage3 } from "../../../Interfaces/cadernos/caderno3";
import BeneficiarioNomeIdAlinhadoDireita from "../../../Componentes_modulo/Beneficiario_nome_id_alinhado_direita";
import { Alert } from "../../../Components/Alert/Alert";
import { AuthContext } from "../../../AuthContext/AuthContext";
import { mensagem_tem_a_certeza_de_apagar_alteracoes } from "../../../Func_genericas/valores_estaticos";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
    },
    contents: {
      flexGrow: 1,
      padding: theme.spacing(1),
    },
    toolbars: {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end",
      padding: theme.spacing(2, 3),
      // necessary for content to be below app bar
      ...theme.mixins.toolbar,
    },
  })
);

export default function CaracterizacaoEfePecuaria() {
  const classes = useStyles();
  const location = useLocation();
  const auth = useContext(AuthContext);
  const is_historico = location.state?.is_historico ?? false;

  const [showNewRow, setShowNewRow] = useState(false);
  const [message, setMessage] = React.useState("");
  const [isLoading, setIsLoading] = useState(true);

  const [openSnackSuccess, setOpenSnackSuccess] = React.useState(false);
  const [openSnackError, setOpenSnackError] = React.useState(false);

  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);

  const [openDelete, setOpenDelete] = React.useState(false);

  const [error_naturais, setError_naturais] = useState<boolean>(false);
  const [error_num_naturais, setErrorNum_naturais] = useState<boolean>(false);
  const [error_normais, setError_normais] = useState<boolean>(false);
  const [error_num_normais, setErrorNum_normais] = useState<boolean>(false);
  const [error_especies, setError_especies] = useState<boolean>(false);
  const [error_grupo_homoge, setError_grupo_homoge] = useState<boolean>(false);
  const [error_classe_etaria, setError_classe_etaria] = useState<boolean>(false);
  const [error_modo_producao, setError_modo_producao] = useState<boolean>(false);
  const [error_finalidade_producao, setError_finalidade_producao] = useState<boolean>(false);
  const message_preencha_campo = ("Preencha este campo");
  const message_apenas_numero = ("Apenas números são aceites");

  const [rows, setRows] = useState<IPage3[]>([]);
  const [newRow, setNewRow] = useState<IPage3>();

  const [flag_editado, set_flag_editado] = React.useState(false);
  const [open_modal_tem_a_certeza_que_quer_apagar_alteracoes, set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes] = React.useState(false);


  const [flag_nova_especie, set_flag_nova_especie] = React.useState(false);
  const [especie_lista_select, set_especie_lista_select] = React.useState<string[]>([]);
  const [flag_nova_finalidade_producao, set_flag_nova_finalidade_producao] = React.useState(false);
  const [finalidade_producao_lista_select, set_finalidade_producao_lista_select] = React.useState<string[]>([]);



  const handleCloseDialog = () => {
    handleCancel()
    set_flag_editado(false)
    set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(false)
  };
  /**************** GET DATA **********************************/
  async function getPecuaria() {
    try {
      let res = await get(auth.token.cookie_token, `/get_caraterizacao_pecuario_id_rosto/${location.state.id_rosto}`);

      if (res.status === 200) {
        setRows(res.data.result);
        let aux_especie_lista_select: string[] = especie
        let aux_finalidade_producao_lista_select: string[] = finalidade_producao_valor_estatico
        res.data.result.forEach((el: IPage3) => {
          if (!especie.includes(el.epecie) && !aux_especie_lista_select.includes(el.epecie)) {
            aux_especie_lista_select.push(el.epecie)
          }
          if (!finalidade_producao_valor_estatico.includes(el.finalidade_producao) && !aux_finalidade_producao_lista_select.includes(el.finalidade_producao)) {
            aux_finalidade_producao_lista_select.push(el.finalidade_producao)
          }
        })
        set_finalidade_producao_lista_select(aux_finalidade_producao_lista_select)
        set_especie_lista_select(aux_especie_lista_select)
      };

      setIsLoading(false);

    } catch (error) {
      func_print("getPecuaria", error, true);
      setMessage("Erro ao efetuar a sua operação!");
      setOpenSnackError(true);

      setIsLoading(false);
    }
  }

  useEffect(() => {
    (async () => {
      await getPecuaria();
    })();
  }, []);

  const handleCancel = () => {
    setShowNewRow(false);
    setNewRow(undefined);
    setError_especies(false);
    setError_grupo_homoge(false);
    setError_classe_etaria(false);
    setError_modo_producao(false);
    setError_finalidade_producao(false);
    setError_naturais(false);
    setError_normais(false);
    setErrorNum_naturais(false);
    setErrorNum_normais(false);
    set_flag_nova_especie(false);
    set_flag_nova_finalidade_producao(false)
  }

  /************************** CREATE ROW *****************************************/
  const handleInputChangeTable = (
    event: ChangeEvent<HTMLInputElement> | SelectChangeEvent<string>
  ) => {
    const { name, value } = event.target;
    set_flag_editado(true)

    if (name === "epecie") {
      if (value.trim() === "") {
        setError_especies(true);

      } else {
        setError_especies(false);
      }
    } else if (name === "grupo_homoge") {
      if (value.trim() === "") {
        setError_grupo_homoge(true);

      } else {
        setError_grupo_homoge(false);
      }
    } else if (name === "classe_etaria") {
      if (value.trim() === "") {
        setError_classe_etaria(true);

      } else {
        setError_classe_etaria(false);
      }
    } else if (name === "modo_producao") {
      if (value.trim() === "") {
        setError_modo_producao(true);

      } else {
        setError_modo_producao(false);
      }
    } else if (name === "finalidade_producao") {
      if (value.trim() === "") {
        setError_finalidade_producao(true);

      } else {
        setError_finalidade_producao(false);
      }
    } else if (name === "naturais") {
      if (value.trim() === "") {
        setError_naturais(true);

      } else if (isNaN(Number(value))) {
        setError_naturais(false);
        setErrorNum_naturais(true);

      } else {
        setError_naturais(false);
        setErrorNum_naturais(false);
      }
    } else if (name === "normais") {
      if (value.trim() === "") {
        setError_normais(true);

      } else if (isNaN(Number(value))) {
        setError_normais(false);
        setErrorNum_normais(true);

      } else {
        setError_normais(false);
        setErrorNum_normais(false);
      }
    }

    setNewRow((prevRows: any) => ({
      ...prevRows,
      [name]: value,
    }));
  };

  const handleSavePagina3 = async () => {
    if (
      !newRow?.epecie || newRow?.epecie.trim() === "" ||
      !newRow?.grupo_homoge || newRow?.grupo_homoge.trim() === "" ||
      !newRow?.classe_etaria || newRow?.classe_etaria.trim() === "" ||
      !newRow?.modo_producao || newRow?.modo_producao.trim() === "" ||
      !newRow?.finalidade_producao || newRow?.finalidade_producao.trim() === "" ||
      !newRow?.naturais || newRow?.naturais.trim() === "" ||
      !newRow?.normais || newRow?.normais.trim() === ""
    ) {
      if (!newRow?.epecie || newRow?.epecie.trim() === "") setError_especies(true);
      if (!newRow?.grupo_homoge || newRow?.grupo_homoge.trim() === "") setError_grupo_homoge(true);
      if (!newRow?.classe_etaria || newRow?.classe_etaria.trim() === "") setError_classe_etaria(true);
      if (!newRow?.modo_producao || newRow?.modo_producao.trim() === "") setError_modo_producao(true);
      if (!newRow?.finalidade_producao || newRow?.finalidade_producao.trim() === "") setError_finalidade_producao(true);
      if (!newRow?.naturais || newRow?.naturais.trim() === "") setError_naturais(true);
      if (!newRow?.normais || newRow?.normais.trim() === "") setError_normais(true);

      setMessage("Preencha todos os campos obrigatórios!");
      setOpenSnackError(true);
      return;
    } else {
      try {
        setIsLoading(true);
        let res = await post(auth.token.cookie_token, "/new_caraterizacao_pecuario", {
          payload: {
            id_cara_pecu: 0,
            epecie: newRow?.epecie === undefined ? "" : newRow.epecie,
            grupo_homoge: newRow?.grupo_homoge === undefined ? "" : newRow.grupo_homoge,
            classe_etaria: newRow?.classe_etaria === undefined ? "" : newRow.classe_etaria,
            modo_producao: newRow?.modo_producao === undefined ? "" : newRow.modo_producao,
            naturais: newRow?.naturais === undefined ? "" : newRow.naturais,
            normais: newRow?.normais === undefined ? "" : newRow.normais,
            finalidade_producao: newRow?.finalidade_producao === undefined ? "" : newRow.finalidade_producao,
            observacoes: newRow?.observacoes === undefined ? "" : newRow.observacoes,
            id_rosto: location.state.id_rosto,
            last_update: new Date().toISOString(),
            create_date: new Date().toISOString(),
            uuid: "",
          }
        });

        if (res.status === 200) {
          setMessage("Gravado com sucesso!");
          setOpenSnackSuccess(true);

          setShowNewRow(false);
          set_flag_editado(false)

          setNewRow(undefined);
          setRows((prevRows) => [
            ...prevRows,
            {
              ...res.data.result,
            },
          ]);
        } else {
          setMessage("Erro ao gravar!");
          setOpenSnackError(true);
        }
        setIsLoading(false);
      } catch (error) {
        func_print("handleSavePagina3", error, true);
        setMessage("Erro ao efetuar a sua operação!");
        setOpenSnackError(true);

        setIsLoading(false);
      }
    }



  };

  /*************** EDITAR LINHA *********************/
  const handleEdit = (obj: IPage3) => {
    setNewRow(obj);
  };

  const onInputChangeEdit = (
    event: ChangeEvent<HTMLInputElement> | SelectChangeEvent<string>
  ) => {
    const { name, value } = event.target;

    set_flag_editado(true)

    if (name === "epecie") {
      if (value.trim() === "") {
        setError_especies(true);

      } else {
        setError_especies(false);
      }
    } else if (name === "grupo_homoge") {
      if (value.trim() === "") {
        setError_grupo_homoge(true);

      } else {
        setError_grupo_homoge(false);
      }
    } else if (name === "classe_etaria") {
      if (value.trim() === "") {
        setError_classe_etaria(true);

      } else {
        setError_classe_etaria(false);
      }
    } else if (name === "modo_producao") {
      if (value.trim() === "") {
        setError_modo_producao(true);

      } else {
        setError_modo_producao(false);
      }
    } else if (name === "finalidade_producao") {
      if (value.trim() === "") {
        setError_finalidade_producao(true);

      } else {
        setError_finalidade_producao(false);
      }
    } else if (name === "naturais") {
      if (value.trim() === "") {
        setError_naturais(true);

      } else if (isNaN(Number(value))) {
        setError_naturais(false);
        setErrorNum_naturais(true);

      } else {
        setError_naturais(false);
        setErrorNum_naturais(false);
      }
    } else if (name === "normais") {
      if (value.trim() === "") {
        setError_normais(true);

      } else if (isNaN(Number(value))) {
        setError_normais(false);
        setErrorNum_normais(true);

      } else {
        setError_normais(false);
        setErrorNum_normais(false);
      }
    }

    setNewRow((prev: any) => ({
      ...prev,
      [name]: value,
    }));

  }

  const handleUpdatePagina3 = async () => {

    if (
      !newRow?.epecie || newRow?.epecie.trim() === "" ||
      !newRow?.grupo_homoge || newRow?.grupo_homoge.trim() === "" ||
      !newRow?.classe_etaria || newRow?.classe_etaria.trim() === "" ||
      !newRow?.modo_producao || newRow?.modo_producao.trim() === "" ||
      !newRow?.finalidade_producao || newRow?.finalidade_producao.trim() === ""
    ) {
      setMessage("Preencha todos os campos obrigatórios!");
      setOpenSnackError(true);
      return;
    }


    try {
      setIsLoading(true);

      const res = await post(auth.token.cookie_token, "/update_caraterizacao_pecuario", {
        payload: newRow,
      });

      if (res.status === 200) {
        setMessage("Registado com sucesso!");


        const updatedRows = rows.map((row) => {
          if (row.id_cara_pecu === newRow?.id_cara_pecu) {
            return res.data.result
          } else {
            return row;
          }
        });
        set_flag_editado(false)

        setRows(updatedRows !== undefined ? updatedRows : []);
        setNewRow(undefined);
        setOpenSnackSuccess(true);
      } else {
        setMessage("Erro ao gravar!");
        setOpenSnackError(true);
      }
      setIsLoading(false);
    } catch (error) {
      func_print("handleUpdatePagina3", error, true);
      setMessage("Erro ao gravar!");
      setOpenSnackError(true);
      setIsLoading(false);
    }


  };

  /************************** DELETE **************************/
  const handleClickOpenDelete = (obj: IPage3) => {
    setNewRow(obj);
    setOpenDelete(true);
  };

  const handleDelete = async () => {
    try {
      setOpenDelete(false);
      setIsLoading(true);
      let res = await del(auth.token.cookie_token, `/delete_caraterizacao_pecuario/${newRow?.id_cara_pecu}`);
      if (res.status === 200) {
        setRows((oldRows) => [
          ...oldRows.filter((oldRow) => oldRow.id_cara_pecu !== newRow?.id_cara_pecu),
        ]);
        setNewRow(undefined)

        setMessage("Registo eliminado com sucesso!");
        setOpenSnackSuccess(true);
      } else {
        setMessage("Erro ao eliminar o registo!");
        setOpenSnackError(true);
      }
      setIsLoading(false);
    } catch (error) {
      func_print("handleDelete", error, true);
      setMessage("Erro ao efetuar a sua operação!");
      setOpenSnackError(true);

      setIsLoading(false);
    }
  };


  /*****************  PAGINAÇÃO ********************** */
  // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;

  const handleChangePage = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <CustomThemeProvider>
      <div className={classes.root}>
        <CadernoLayout title="3 - Caraterização do Efetivo Pecuário" />
        <main className={classes.contents}>
          <div className={classes.toolbars} />

          <>
            <Box width="80%" margin="auto">
              <BeneficiarioNomeIdAlinhadoDireita />
            </Box>
            <Snackbar
              open={openSnackSuccess}
              autoHideDuration={2000}
              onClose={() => setOpenSnackSuccess(false)}
            >
              <Alert
                onClose={() => setOpenSnackSuccess(false)}
                severity="success"
                sx={{ width: "100%" }}
              >
                {message}
              </Alert>
            </Snackbar>
            <Snackbar
              open={openSnackError}
              autoHideDuration={2000}
              onClose={() => setOpenSnackError(false)}
            >
              <Alert
                onClose={() => setOpenSnackError(false)}
                severity="error"
                sx={{ width: "100%" }}
              >
                {message}
              </Alert>
            </Snackbar>
            {isLoading ? (
              <LoadingVulpes />
            ) : (
              <TableContainer
                component={Paper}
                variant="outlined"
                sx={{ height: "auto", padding: 2, margin: 2, width: "auto" }}
              >
                <table style={{ width: "100%" }}>
                  <TableHead>
                    <TableRow>
                      <TableCell
                        colSpan={8}
                        sx={{
                          fontWeight: 600,
                          fontSize: 20,
                          fontFamily: "candara",
                        }}
                      >
                        3 - Caraterização do Efetivo Pecuário
                        <BasicPopover
                          text={
                            "Preenchimento obrigatório para os beneficiários que detenham animais certificados em modo de produção biológico ou PRODI."
                          }
                        />
                      </TableCell>
                      <TableCell>
                        {
                          is_historico === true ? <></> :
                            <BarraDeFerramentas
                              mostrarBotaoNovo
                              textoBotaoNovo="Novo Registo"
                              aoClicarNovo={() => {

                                handleCancel();
                                setShowNewRow(true)
                              }}
                            />
                        }
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <StyledTableHead rowSpan={2} sx={{ minWidth: 150 }}>
                        Espécie / Raça*
                      </StyledTableHead>
                      <StyledTableHead rowSpan={2}>
                        Grupo Homogéneo*
                      </StyledTableHead>
                      <StyledTableHead rowSpan={2}>
                        Classe Etária*
                      </StyledTableHead>
                      <StyledTableHead rowSpan={2}>
                        Modo de <br />
                        <Stack direction="row" justifyContent="center">
                          produção*
                          <BasicPopover
                            text={
                              "Modo de Produção Biológico ou Produção Integrada"
                            }
                          />
                        </Stack>
                      </StyledTableHead>
                      <StyledTableHead colSpan={2}>
                        Nº de Cabeças
                      </StyledTableHead>
                      <StyledTableHead rowSpan={2} sx={{ minWidth: 150 }}>
                        Finalidade da produção*
                      </StyledTableHead>
                      <StyledTableHead rowSpan={2} sx={{ minWidth: 180 }}>
                        Outras Observações
                      </StyledTableHead>
                      <StyledTableHead rowSpan={3}>Ações</StyledTableHead>
                    </TableRow>

                    <TableRow>
                      <StyledTableHead>Naturais*</StyledTableHead>
                      <StyledTableHead>Normais (CN)*</StyledTableHead>
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {showNewRow && (
                      <TableRow>
                        <StyledTableCell>
                          {
                            flag_nova_especie === true ?
                              <CustomTextField
                                name="epecie"
                                value={newRow?.epecie}
                                onChange={handleInputChangeTable}
                                error={error_especies}
                                helperText={error_especies ? message_preencha_campo : ""}
                              />
                              :
                              <CustomSelect
                                value={newRow?.epecie === undefined ? "" : newRow.epecie}
                                name="epecie"
                                onChange={(e) => {
                                  handleInputChangeTable(e)
                                  especie_lista_select.slice(6).includes(e.target.value) ?
                                    set_flag_nova_especie(true) : set_flag_nova_especie(false)
                                }}
                                options={especie_lista_select}
                                label=""
                                minWidth={120}
                              />
                          }

                        </StyledTableCell>
                        <StyledTableCell>
                          <CustomTextField
                            name="grupo_homoge"
                            value={newRow?.grupo_homoge}
                            onChange={handleInputChangeTable}
                            error={error_grupo_homoge}
                            helperText={error_grupo_homoge ? message_preencha_campo : ""}
                          />
                        </StyledTableCell>
                        <StyledTableCell>
                          <CustomTextField
                            name="classe_etaria"
                            value={newRow?.classe_etaria}
                            onChange={handleInputChangeTable}
                            error={error_classe_etaria}
                            helperText={error_classe_etaria ? message_preencha_campo : ""}
                          />
                        </StyledTableCell>
                        <StyledTableCell>
                          <CustomSelect
                            value={newRow?.modo_producao !== undefined ? newRow.modo_producao : ""}
                            name="modo_producao"
                            options={modoProducao}
                            label={"Modo de produção"}
                            onChange={handleInputChangeTable}
                            minWidth={120}
                          />
                          {error_modo_producao && (
                            <p style={{ color: "#c90606", fontSize: 11 }}>
                              {message_preencha_campo}
                            </p>
                          )}
                        </StyledTableCell>
                        <StyledTableCell>
                          <CustomTextField
                            name="naturais"
                            value={newRow?.naturais}
                            onChange={handleInputChangeTable}
                            error={error_naturais || error_num_naturais}
                            helperText={error_naturais ? message_preencha_campo : error_num_naturais ? message_apenas_numero : ""}
                          />
                        </StyledTableCell>
                        <StyledTableCell>
                          <CustomTextField
                            name="normais"
                            value={newRow?.normais}
                            onChange={handleInputChangeTable}
                            error={error_normais || error_num_normais}
                            helperText={error_normais ? message_preencha_campo : error_num_normais ? message_apenas_numero : ""}
                          />
                        </StyledTableCell>
                        <StyledTableCell>

                          {
                            flag_nova_finalidade_producao === true ?
                              <CustomTextField
                                name="finalidade_producao"
                                value={newRow?.finalidade_producao}
                                onChange={handleInputChangeTable}
                                error={error_finalidade_producao}
                                helperText={error_finalidade_producao ? message_preencha_campo : ""}
                              />
                              :
                              <CustomSelect
                                value={newRow?.finalidade_producao === undefined ? "" : newRow.finalidade_producao}
                                name="finalidade_producao"
                                onChange={(e) => {
                                  handleInputChangeTable(e)
                                  finalidade_producao_lista_select.slice(2).includes(e.target.value) ?
                                    set_flag_nova_finalidade_producao(true) : set_flag_nova_finalidade_producao(false)
                                }}
                                options={finalidade_producao_lista_select}
                                label=""
                                minWidth={120}
                              />
                          }
                        </StyledTableCell>
                        <StyledTableCell>
                          <CustomTextField
                            name="observacoes"
                            value={newRow?.observacoes}
                            onChange={handleInputChangeTable}
                          />
                        </StyledTableCell>
                        <StyledTableCell>
                          <ButtonCadernos
                            mostrarBotaoCancelar
                            aoClicarCancelar={() => {
                              if (flag_editado) {
                                set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(true)
                              } else {
                                handleCancel()
                              }
                            }}
                            mostrarBotaoGravar
                            aoClicarGravar={() => handleSavePagina3()}
                          />
                        </StyledTableCell>
                      </TableRow>
                    )}

                    {(rowsPerPage > 0
                      ? rows.slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage
                      )
                      : rows
                    ).map((row, key) => {
                      return (
                        <TableRow key={key}>
                          {newRow?.id_cara_pecu === row.id_cara_pecu ? (
                            <>
                              <StyledTableCell>

                                {
                                  flag_nova_especie === true ?
                                    <CustomTextField
                                      name="epecie"
                                      value={newRow?.epecie}
                                      onChange={handleInputChangeTable}
                                      error={error_especies}
                                      helperText={error_especies ? message_preencha_campo : ""}
                                    />
                                    :
                                    <CustomSelect
                                      value={newRow?.epecie === undefined ? "" : newRow.epecie}
                                      name="epecie"
                                      onChange={(e) => {
                                        handleInputChangeTable(e)
                                        especie_lista_select.slice(6).includes(e.target.value) ?
                                          set_flag_nova_especie(true) : set_flag_nova_especie(false)
                                      }}
                                      options={especie_lista_select}
                                      label=""
                                      minWidth={120}
                                    />
                                }
                              </StyledTableCell>
                              <StyledTableCell>
                                <CustomTextField
                                  name="grupo_homoge"
                                  value={newRow?.grupo_homoge !== undefined ? newRow?.grupo_homoge : ""}
                                  onChange={onInputChangeEdit}
                                  error={error_grupo_homoge}
                                  helperText={error_grupo_homoge ? message_preencha_campo : ""}
                                />
                              </StyledTableCell>
                              <StyledTableCell>
                                <CustomTextField
                                  name="classe_etaria"
                                  value={newRow?.classe_etaria !== undefined ? newRow?.classe_etaria : ""}
                                  onChange={onInputChangeEdit}
                                  error={error_classe_etaria}
                                  helperText={error_classe_etaria ? message_preencha_campo : ""}
                                />
                              </StyledTableCell>
                              <StyledTableCell>
                                <CustomSelect
                                  value={newRow?.modo_producao !== undefined ? newRow?.modo_producao : ""}
                                  name="modo_producao"
                                  options={modoProducao}
                                  label={"Modo de produção"}
                                  onChange={onInputChangeEdit}
                                  minWidth={120}
                                />
                              </StyledTableCell>
                              <StyledTableCell>
                                <CustomTextField
                                  name="naturais"
                                  value={newRow?.naturais !== undefined ? newRow?.naturais : ""}
                                  onChange={onInputChangeEdit}
                                  error={error_naturais || error_num_naturais}
                                  helperText={error_naturais ? message_preencha_campo : error_num_naturais ? message_apenas_numero : ""}
                                />
                              </StyledTableCell>
                              <StyledTableCell>
                                <CustomTextField
                                  name="normais"
                                  value={newRow?.normais !== undefined ? newRow?.normais : ""}
                                  onChange={onInputChangeEdit}
                                  error={error_normais}
                                  helperText={error_normais ? message_preencha_campo : error_num_normais ? message_apenas_numero : ""}
                                />
                              </StyledTableCell>
                              <StyledTableCell>
                                {
                                  flag_nova_finalidade_producao === true ?
                                    <CustomTextField
                                      name="finalidade_producao"
                                      value={newRow?.finalidade_producao}
                                      onChange={handleInputChangeTable}
                                      error={error_finalidade_producao}
                                      helperText={error_finalidade_producao ? message_preencha_campo : ""}
                                    />
                                    :
                                    <CustomSelect
                                      value={newRow?.finalidade_producao === undefined ? "" : newRow.finalidade_producao}
                                      name="finalidade_producao"
                                      onChange={(e) => {
                                        handleInputChangeTable(e)

                                        finalidade_producao_lista_select.slice(2).includes(e.target.value) ?
                                          set_flag_nova_finalidade_producao(true) : set_flag_nova_finalidade_producao(false)
                                      }}
                                      options={finalidade_producao_lista_select}
                                      label=""
                                      minWidth={120}
                                    />
                                }
                              </StyledTableCell>
                              <StyledTableCell>
                                <CustomTextField
                                  name="observacoes"
                                  value={newRow?.observacoes !== undefined ? newRow?.observacoes : ""}
                                  onChange={onInputChangeEdit}
                                />
                              </StyledTableCell>
                            </>
                          ) : (
                            <>
                              <StyledTableCell>{row.epecie}</StyledTableCell>
                              <StyledTableCell>
                                {row.grupo_homoge}
                              </StyledTableCell>
                              <StyledTableCell>
                                {row.classe_etaria}
                              </StyledTableCell>
                              <StyledTableCell>
                                {row.modo_producao}
                              </StyledTableCell>
                              <StyledTableCell>{row.naturais}</StyledTableCell>
                              <StyledTableCell>{row.normais}</StyledTableCell>
                              <StyledTableCell>
                                {row.finalidade_producao}
                              </StyledTableCell>
                              <StyledTableCell>
                                {row.observacoes}
                              </StyledTableCell>
                            </>
                          )}

                          {newRow?.id_cara_pecu === row.id_cara_pecu ? (
                            <StyledTableCell>
                              <ButtonCadernos
                                mostrarBotaoGravar
                                aoClicarGravar={() => handleUpdatePagina3()}
                                mostrarBotaoCancelar
                                aoClicarCancelar={() => {
                                  if (flag_editado) {
                                    set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(true)
                                  } else {
                                    handleCancel()
                                  }
                                }}
                              />
                            </StyledTableCell>
                          ) : (
                            <StyledTableCell>
                              {
                                is_historico === true ? <></> :
                                  <ButtonCadernos
                                    mostrarBotaoEditar
                                    aoClicarEditar={() => {
                                      handleCancel();
                                      handleEdit(row)
                                    }}
                                    mostrarBotaoApagar
                                    aoClicarApagar={() =>
                                      handleClickOpenDelete(row)
                                    }
                                  />
                              }
                            </StyledTableCell>
                          )}

                        </TableRow>

                      );
                    })}

                    {emptyRows > 0 && (
                      <TableRow style={{ height: 53 * emptyRows }}>
                        <TableCell colSpan={12} />
                      </TableRow>
                    )}
                  </TableBody>
                  <Typography style={{ fontSize: 14, fontFamily: "candara", padding: 10 }}>
                    * Campos de preenchimento obrigatório
                  </Typography>
                  <TableFooter>

                    <TableRow sx={{ width: "100%" }}>
                      <TablePagination
                        rowsPerPageOptions={[
                          5,
                          10,
                          25,
                          { label: "Tudo", value: -1 },
                        ]}
                        colSpan={14}
                        count={rows.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        labelDisplayedRows={({ from, to, count }) => {
                          return `${from}–${to} de ${count !== -1 ? count : `mais do que ${to}`}`;
                        }}
                        labelRowsPerPage={'Linhas por página'}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                        ActionsComponent={TablePaginationActions}
                      />
                    </TableRow>
                  </TableFooter>
                </table>
              </TableContainer>

            )}
            <ConfirmDialog
              open={openDelete}
              onClose={() => setOpenDelete(false)}
              onConfirm={handleDelete}
              message="Deseja eliminar o registo?"
            />
          </>
          <ConfirmDialog
            open={open_modal_tem_a_certeza_que_quer_apagar_alteracoes}
            onClose={() => set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(false)}
            onConfirm={() => handleCloseDialog()}
            message={mensagem_tem_a_certeza_de_apagar_alteracoes}
          />
        </main>
      </div>
    </CustomThemeProvider>
  );
}
